import React from "react";
import { Bot, Users, PlayCircle, Laptop, Cpu, ShieldCheck } from "lucide-react";
import StickyScroller from "./StickyScroller";

const serviceItems = [
  {
    title: "AI & Intelligent Automation",
    description:
      "LLM-powered solutions including RAG chatbots, voice agents, document intelligence, and conversational AI.",
    icon: Bot,
  },
  {
    title: "Consultancy Services",
    description:
      "Managed services and resource sharing with US startups for 10+ years. Available on Time & Material basis.",
    icon: Users,
  },
  {
    title: "OTT & Media Solutions",
    description:
      "Content monetization (AVOD, SVOD, TVOD), DRM, media transcoding, and recommendation engines.",
    icon: PlayCircle,
  },
  {
    title: "Enterprise Software",
    description:
      "Full-stack development including ERP, LMS, SIS, HR modules, and higher education platforms.",
    icon: Laptop,
  },
  {
    title: "IoT & Big Data",
    description: "Real-time streaming data processing, IoT device backends, and smart device integration.",
    icon: Cpu,
  },
  {
    title: "Authorization-as-a-Service",
    description: "Fine-grained data access control, REST API exposure, and configurable security policies.",
    icon: ShieldCheck,
  },
];

export default function OurServices() {
  return (
    <StickyScroller
      side="left"
      eyebrow="What we do"
      title="Comprehensive Digital & Enterprise Solutions"
      description="Comprehensive solutions across AI, web, and app development to elevate your business and drive innovation. Keep scrolling to move through everything we offer."
      accent="#1a56db"
      items={serviceItems}
      renderBadge={(item) => {
        const Icon = item.icon;
        return <Icon size={22} />;
      }}
    />
  );
}